// extracted by mini-css-extract-plugin
export default {"-large":"autosave-onboarding-popup-module__-large--p1Lth","container":"autosave-onboarding-popup-module__container--YovgS","arrow":"autosave-onboarding-popup-module__arrow--JnqGo"};